import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";

async function getMaintenance() {
  const data = await axiosInstance({
    url: "/maintenance",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createMaintenance = async (formData: any) => {
  const data = await axiosInstance({
    url: "/maintenance",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateMaintenance = async (formData: any) => {
  const data = await axiosInstance({
    url: `/maintenance/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteMaintenance = async (formData: any) => {
  const data = await axiosInstance({
    url: `/maintenance/${formData}?hard=true`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useMaintenance() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.maintenance],
    queryFn: () => getMaintenance(),
  });
  return data;
}

export function useCreateMaintenance() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createMaintenance(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.maintenance]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateMaintenance() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateMaintenance(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.maintenance]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteMaintenance() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteMaintenance(formData),
    onSuccess: (data) => {
      //   toast.success("Maintenance Deleted Successfully", toastOptions);
      queryClient.invalidateQueries([queryKeys.maintenance]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
